import {DialogDismiss, DialogHeader, DialogHeading} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from 'react-i18next'
import {StyledEventDetailsHeaderTitle} from './style'
import {CalendarIcon} from '@/components/ui/icon/Icon'

export const AgendaGenericEventDetailsDialogHeader = () => {
    const {t} = useTranslation()
    return (
        <DialogHeader>
            <DialogHeading>
                <Flexbox gap={2} align="center">
                    <StyledEventDetailsHeaderTitle gap={2} align="center">
                        <CalendarIcon size={18} />
                        <span>{t('agenda:appointment_type_generic_event')}</span>
                    </StyledEventDetailsHeaderTitle>
                </Flexbox>
            </DialogHeading>
            <DialogDismiss />
        </DialogHeader>
    )
}
